import React from 'react';
import { MFAVerify } from '@/features/auth';
import PageMeta from '@/shared/components/PageMeta';

export const MFAVerification: React.FC = () => {
    return (
        <>
            <PageMeta
                title="Two-Factor Authentication"
                description="Complete your login with two-factor authentication"
            />
            <MFAVerify />
        </>
    );
};
